import { render, staticRenderFns } from "./EvaluaCurso.vue?vue&type=template&id=2126f3e1&scoped=true"
import script from "./EvaluaCurso.vue?vue&type=script&lang=js"
export * from "./EvaluaCurso.vue?vue&type=script&lang=js"
import style0 from "./EvaluaCurso.vue?vue&type=style&index=0&id=2126f3e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126f3e1",
  null
  
)

export default component.exports